module.exports = __webpack_public_path__ + "img/loading.951c2859.gif";